import { Navigate } from "react-router-dom";
import { AuthContext } from "../helpers/AuthContext";
import { useContext } from "react";

const LoggedInProtectedRoute = ({ children }) => {
  const { authState } = useContext(AuthContext);

  if (authState.status) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/newParty" />;
  }

  // If authenticated, render the component
  return children;
};

export default LoggedInProtectedRoute;
